import React from 'react'
import { Subheading, Separator, H3 } from '@fs/zion-ui'
import styles from './GraphicalHeaderBlock.styles'

export default function GraphicalHeaderBlock({
  src,
  width = '75%',
  maxWidth = '700px',
  heading,
  subHeading,
  gap = null,
  children,
}) {
  return (
    <div css={styles.wrapper}>
      <img css={styles.graphic(width, maxWidth)} src={src} alt="" aria-hidden draggable={false} />
      {gap && <Separator size={gap} />}
      <H3 centered>
        {heading}
        <Subheading>{subHeading}</Subheading>
      </H3>
      {children}
    </div>
  )
}
